import React from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/400-italic.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/open-sans/800.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "./color-theme.scss";
import "./index.scss";
import "./animate.css";
import "./buttons.scss";
import App from "./App";
import Store from "./context/Store";
import rootReducer from "./context/rootReducer";

const root = createRoot(document.getElementById("root"));
root.render(
  <Store rootReducer={rootReducer}>
    <App />
  </Store>
);
